import { api } from '@core/api/apiClient';
import type { SpecialEventGroup } from '../types/specialEvent';

interface SpecialEventGroupResponse {
  specialEventGroup: {
    title: string;
    description: string;
    dates: string[];
    serviceTypes: string[];
    translations: Record<string, { title?: string; description?: string }>;
  };
}

export async function fetchSpecialEventGroup(
  subdomain: string,
  slug: string,
): Promise<SpecialEventGroup> {
  const response = await api.get<SpecialEventGroupResponse>(
    `/api/restaurants/${subdomain}/special-event-groups/${slug}`,
  );

  const seg = response.specialEventGroup;

  return {
    slug,
    title: seg.title,
    description: seg.description,
    dates: Array.from(new Set(seg.dates.map((d) => d.split('T')[0]))).sort(),
    serviceTypes: seg.serviceTypes,
    translations: seg.translations ?? {},
  };
}
